import React from "react";
interface IconProps extends React.SVGProps<SVGSVGElement> {
  color?: string;
  size?: number | string;
}

const Glasses:React.FC<IconProps> = ({
  color = "#2625e9",
  size = 40,
  className,
  style,
  ...props
}) => (
  <svg
    transform="scale(1.5)"
    viewBox="0 0 80 80"
    style={{ width: size, height: size, flexShrink: 0, ...style }}
    aria-hidden="true"
    className={className}
    {...props}
  >
<g transform="translate(0,-0)">
    <path
      d="M46.9 61.78c-2.36 0-4.69-.06-6.9-.21-13.33.87-30.63-1.23-37.45-2.17A3.895 3.895 0 01-.1 57.81c-.64-.88-.88-1.95-.69-3.02l6.02-33.32c.2-1.09.81-2.01 1.74-2.61.91-.59 2.05-.78 3.1-.52C24.3 21.89 39.85 22 40 22c.15 0 15.7-.11 29.93-3.66 1.06-.26 2.19-.08 3.1.52.93.6 1.54 1.53 1.74 2.61l6.02 33.32c.19 1.07-.05 2.14-.69 3.02-.64.88-1.58 1.44-2.65 1.59-5.69.79-18.67 2.38-30.55 2.38zM9.1 19.38c-.53 0-1.05.15-1.51.45-.65.42-1.09 1.08-1.23 1.85L.34 54.99c-.14.76.04 1.51.49 2.14a2.8 2.8 0 001.87 1.13c6.8.94 24.03 3.03 37.26 2.16h.08c13.23.87 30.46-1.22 37.26-2.16.76-.11 1.43-.5 1.87-1.13.45-.62.62-1.38.49-2.14l-6.02-33.32c-.14-.77-.58-1.42-1.23-1.85-.66-.42-1.44-.55-2.2-.36-14.37 3.58-30.05 3.69-30.21 3.69-.16 0-15.85-.11-30.21-3.69a2.71 2.71 0 00-.69-.08z"
      fill={color}
    />
    <path
      d="M41.49 58.32c-.15 0-.29-.06-.4-.16a.599.599 0 01-.18-.42V25.43c0-.16.06-.31.18-.42s.26-.17.42-.16c18.65.57 29.26-3.04 29.37-3.07.16-.06.34-.04.49.05.15.09.25.24.27.4l5.34 32.68c.03.19-.03.38-.17.51-.36.34-1.19 1.13-18.45 2.12-8.43.48-16.77.77-16.85.78h-.02zm.58-32.29v31.11c12.13-.43 30.98-1.44 33.7-2.44L70.6 23.08c-2.57.76-12.63 3.37-28.53 2.95zM38.57 58.32h-.02c-.08 0-8.42-.3-16.85-.78-17.26-.99-18.09-1.78-18.45-2.12a.568.568 0 01-.17-.51l5.34-32.68a.575.575 0 01.76-.45c.11.04 10.74 3.65 29.37 3.07.15 0 .31.05.42.16.11.11.18.26.18.42v32.31c0 .16-.06.31-.18.42-.11.1-.25.16-.4.16zM4.28 54.71c2.67.99 21.55 2 33.7 2.44V26.04c-15.91.42-25.96-2.19-28.53-2.95L4.28 54.72z"
      fill={color}
    />
    <path
      d="M14.52 60.79a.576.576 0 01-.37-1.02l19.56-16.58c.24-.21.61-.18.81.07.21.24.18.61-.07.82L14.89 60.66c-.11.09-.24.14-.37.14z"
      fill={color}
    />
    <path
      d="M34.08 53.43a.58.58 0 01-.58-.58V34.33a.58.58 0 011.16 0v18.52c0 .32-.26.58-.58.58zM64.99 60.79c-.13 0-.26-.04-.37-.14L45.06 44.07a.594.594 0 01-.07-.82c.21-.24.57-.27.81-.07l19.56 16.58c.24.21.27.57.07.82-.11.13-.28.2-.44.2z"
      fill={color}
    />
    <path
      d="M45.43 53.43a.58.58 0 01-.58-.58V34.33a.58.58 0 011.16 0v18.52c0 .32-.26.58-.58.58z"
      fill={color}
    />
    </g>
  </svg>
);

export default Glasses;
